import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { API_ENDPOINT } from '../constants';
import { fetchWrapper } from '../helpers';

import type { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import type { ITherapyUtilization } from '../utils/types';

const name = 'utilizations';
const initialState = createInitialState();
const reducers = createReducers();
// SAFETY: Legacy thunk action creators use the store dispatch result contract.
const extraActions = createExtraActions() as any;
const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder: ActionReducerMapBuilder<UtilizationState>) =>
    createExtraReducers(builder),
});

export interface UtilizationState {
  data: ITherapyUtilization[] | null;
  error: any;
  loading: boolean;
}

function createInitialState(): UtilizationState {
  return {
    data: null,
    loading: false,
    error: null,
  };
}

function createReducers() {
  return { clearState };

  function clearState(state: UtilizationState) {
    state.data = null;
    state.loading = false;
    state.error = null;
  }
}

function createExtraActions() {
  const baseUrl = `${API_ENDPOINT}/sessions/data/utilization`;

  return {
    getUtilization: getUtilization(),
  };

  function getUtilization() {
    return createAsyncThunk(
      `${name}`,
      async ({ getAccessTokenSilently, clientIds, startDate, endDate, utcOffset }: any) => {
        const response = await fetchWrapper.get({
          url: `${baseUrl}/?client_ids=${clientIds}&start=${startDate}&end=${endDate}&utc_offset=${utcOffset}`,
          getAccessTokenSilently,
        });
        return response;
      },
    );
  }
}

function createExtraReducers(builder: ActionReducerMapBuilder<UtilizationState>) {
  const { getUtilization } = extraActions;

  builder
    .addCase(getUtilization.pending, (state: UtilizationState) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(getUtilization.fulfilled, (state: UtilizationState, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.loading = false;
    })
    .addCase(getUtilization.rejected, (state: UtilizationState, action: any) => {
      state.data = null;
      state.error = action.error;
      state.loading = false;
    });
}

export const utilizationActions = { ...slice.actions, ...extraActions };
export const utilizationReducer = slice.reducer;
